import { render } from "./ServiceComponent.vue?vue&type=template&id=72d581e4&scoped=true"
import script from "./ServiceComponent.vue?vue&type=script&lang=js"
export * from "./ServiceComponent.vue?vue&type=script&lang=js"

import "./ServiceComponent.vue?vue&type=style&index=0&id=72d581e4&scoped=true&lang=css"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d581e4"]])

export default __exports__